import AxiosInstance from '../../core/api/axiosinstance'
import promiseToResult from '../../core/api/promiseToResults'
import { querystring } from '../../shared/utils'
import { Content, WithMetadata } from './_types'

export interface RoundStatistics {
  collectedPrice: number
  targetPrice: number
  percent: number
}

export const defaultRoundStatistics: RoundStatistics = {
  collectedPrice: 0,
  targetPrice: 0,
  percent: 0,
}

export interface Round {
  id: number
  projectId: number
  title: Content[]
  description: Content[]
  attachments: string[]
  targetPrice: number
  startsAt: string
  endsAt: string
  status: string
  allowedRoles: string[]
  internalComment: string
  statistics?: RoundStatistics
  createdBy: number
  updatedBy: number
  createdAt: string
  updatedAt: string
}

export interface GetRoundsReq {
  limit?: string | number
  page?: string | number
  projectId?: string | number
  status?: string
  active?: boolean
  orderBy?: string
  orderDirection?: string
}

export type GetRoundsRes = WithMetadata<Round>

const getRounds = (data: GetRoundsReq) => {
  return promiseToResult(
    AxiosInstance().get<GetRoundsRes>(
      `/projects/admin/rounds?${querystring.stringify(data)}`,
    ),
  )
}

export interface GetRoundReq {
  id: string | number
}

export type GetRoundRes = Round

const getRound = (data: GetRoundReq) => {
  return promiseToResult(
    AxiosInstance().get<GetRoundRes>(
      `/projects/admin/rounds/${data.id}`,
    ),
  )
}

export interface PostRoundReq {
  projectId: number
  title: Content[]
  description: Content[]
  targetPrice: number
  startsAt: string
  endsAt: string
  attachments?: string[]
  status?: string
  allowedRoles?: string[]
  internalComment?: string
}

export type PostRoundRes = Round

const postRound = (data: PostRoundReq) => {
  return promiseToResult(
    AxiosInstance().post<PostRoundRes>(
      '/projects/admin/rounds',
      data,
    ),
  )
}

export type PatchRoundReq = PostRoundReq & { id: string | number }
export type PatchRoundRes = Round

const patchRound = (data: PatchRoundReq) => {
  const { id, ...body } = data
  return promiseToResult(
    AxiosInstance().patch<PatchRoundRes>(
      `/projects/admin/rounds/${id}`,
      body,
    ),
  )
}

export const RoundsAPI = {
  getRounds,
  getRound,
  postRound,
  patchRound,
}
